<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div
        class="button-back pb-1"
        [routerLink]="['/on-demand/instantaneous-object']"
      >
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-6">
      <h2 class="col pb-2 m-0 title">
        {{ "INSTANTANEOUS_OBJECT_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "ONDEMANDINSTANTANEOUS_SUBTITLE" | translate }}
      </h6>
    </div>
    @if (
      authService.isAuthorized([
        PermissionEnum.Ondemand_instantaneousobject_download,
      ])
    ) {
      <div
        class="col-md-5 d-flex justify-content-end align-items-center gap-2 pe-5"
      >
        <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
          <svg-icon
            alt="Download"
            class="hover-effect"
            src="assets/core/table/download.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }}
          </td>
          <td colspan="3">{{ "INSTANTANEOUSVOLTAGE" | translate }}</td>
          <td colspan="3">{{ "AVERAGE_VOLTAGE" | translate }}</td>
          <td colspan="3">{{ "INSTANTANEOUSCURRENT" | translate }}</td>
          <td colspan="3">{{ "AVERAGE_CURRENT" | translate }}</td>
          <td colspan="3" class="custom-width">{{ "POWERFACTOR" | translate }}</td>
          <td class="custom-width">{{ "FREQUENCY" | translate }}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Instantaneous Voltage -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.instantaneousVoltageL1 + ' V'"
                >{{ item.instantaneousVoltageL1 == null ? "N/A" :
                   (item.instantaneousVoltageL1 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.instantaneousVoltageL2 + ' V'"
                >{{ item.instantaneousVoltageL2 == null ? "N/A" :
                   (item.instantaneousVoltageL2 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.instantaneousVoltageL3 + ' V'"
                >{{ item.instantaneousVoltageL3 == null ? "N/A" :
                   (item.instantaneousVoltageL3 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>

          <!-- Average Voltage -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.averageVoltageL1 + ' V'"
                >{{ item.averageVoltageL1 == null ? "N/A" :
                   (item.averageVoltageL1 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.averageVoltageL2 + ' V'"
                >{{ item.averageVoltageL2 == null ? "N/A" :
                   (item.averageVoltageL2 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.averageVoltageL3 + ' V'"
                >{{ item.averageVoltageL3 == null ? "N/A" :
                   (item.averageVoltageL3 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>

          <!-- Instantaneous Current -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.instantaneousCurrentL1 + ' A'"
                >{{ item.instantaneousCurrentL1 == null ? "N/A" :
                   (item.instantaneousCurrentL1 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.instantaneousCurrentL2 + ' A'"
                >{{ item.instantaneousCurrentL2 == null ? "N/A" :
                   (item.instantaneousCurrentL2 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.instantaneousCurrentL3 + ' A'"
                >{{ item.instantaneousCurrentL3 == null ? "N/A" :
                   (item.instantaneousCurrentL3 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>

          <!-- Average Current -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.averageCurrentL1 + ' A'"
                >{{ item.averageCurrentL1 == null ? "N/A" :
                   (item.averageCurrentL1 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.averageCurrentL2 + ' A'"
                >{{ item.averageCurrentL2 == null ? "N/A" :
                   (item.averageCurrentL2 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.averageCurrentL3 + ' A'"
                >{{ item.averageCurrentL3 == null ? "N/A" :
                   (item.averageCurrentL3 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>

          <!-- Power Factor -->
          <!-- <td>
            <span [attr.title]="item.instantaneousPowerFactor">{{
              item.instantaneousPowerFactor | number: "1.0-4"
            }}</span>
          </td> -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.instantaneousPowerFactorL1"
                >{{ item.instantaneousPowerFactorL1 == null ? "N/A" :
                   item.instantaneousPowerFactorL1 | number: "1.0-4" }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.instantaneousPowerFactorL2 "
                >{{ item.instantaneousPowerFactorL2 == null ? "N/A" :
                   item.instantaneousPowerFactorL2 | number: "1.0-4" }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.instantaneousPowerFactorL3 "
                >{{ item.instantaneousPowerFactorL3 == null ? "N/A" :
                   item.instantaneousPowerFactorL3 | number: "1.0-4" }}</span
              >
            </div>
          </td>

          <!-- Frequency -->
          <td>
            <span [attr.title]="item.instantaneousFrequency"
              >{{ item.instantaneousFrequency == null ? "N/A" :
                 (item.instantaneousFrequency | number: "1.0-4") + ' Hz' }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfCommands"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>
